import { Typography, styled } from '@mui/material';
import colors from 'assets/themes/zizzi/colors';

export const StyledBox = styled('div')`
  padding: 0px 8px 8px;
`;

export const StyledTypography = styled(Typography)`
  border-bottom: 1px solid ${colors.palette.primary.main};
  cursor: pointer;
  display: inline;
`;
